const VALID_TIERS = new Set(["lite", "growth", "pro"]);
export function isValidTier(value) {
    return VALID_TIERS.has(value);
}
export const NO_SUBSCRIPTION_LIMITS = {
    maxKeywords: 0,
    maxAuditPages: 0,
    maxArticles: 0,
    maxProjects: 1,
    manualCooldownHours: 0,
    hasAlerts: false,
    hasCsvExport: false,
};
export const TIER_CONFIG = {
    lite: {
        maxKeywords: 50,
        maxAuditPages: 25,
        maxArticles: 5,
        maxProjects: 2,
        manualCooldownHours: 0,
        hasAlerts: false,
        hasCsvExport: false,
    },
    growth: {
        maxKeywords: 200,
        maxAuditPages: 200,
        maxArticles: 20,
        maxProjects: 3,
        manualCooldownHours: 24,
        hasAlerts: true,
        hasCsvExport: true,
    },
    pro: {
        maxKeywords: 750,
        maxAuditPages: 1000,
        maxArticles: 50,
        maxProjects: 7,
        manualCooldownHours: 24,
        hasAlerts: true,
        hasCsvExport: true,
    },
};
export const TIER_ORDER = ["lite", "growth", "pro"];
export const TIER_PRICES = {
    lite: "$19/mo",
    growth: "$49/mo",
    pro: "$89/mo",
};
